// extracted by mini-css-extract-plugin
module.exports = {"vBlue10":"#ccf2ff","user":"MessengerSearchItem_user__2-SVH","highlight":"MessengerSearchItem_highlight__gOgFb"};